import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEqual } from "lodash";
import moment from "moment";
import { DatePicker } from "antd";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import MerchandiserInvoicingStatuses from "data/merchandiser-invoicing-statuses";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import CustomCheckbox from "components/custom/forms/custom-checkbox";
import statusFilter from "components/menu/invoicing/merchandiser/status-filter";
import UserTypes from "components/auth/user-types";

class ListChargesCharges extends Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.tableRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if (!isEqual(nextProps.charges, this.props.charges)) {
            return true;
        } else if (!isEqual(nextProps.selectedCharges, this.props.selectedCharges)) {
            return true;
        } else if (nextProps.isAdminView !== this.props.isAdminView) {
            return true;
        }
        return false;
    }

    getColumns = () => {
        const {
            isAdminView,
            isAccountManagerView,
            charges,
            selectedCharges
        } = this.props;

        const columns = [];

        if (isAdminView || isAccountManagerView) {
            columns.push({
                Cell: ({ original }) => (
                    <CustomCheckbox
                        key={original.chargeId}
                        className="checkbox"
                        checked={selectedCharges[original.chargeId] === true}
                        onChange={() => this.props.onToggle(original.chargeId)}
                    />
                ),
                headerClassName: "text-left",
                Header: () => (
                    <input
                        type="checkbox"
                        className="checkbox"
                        checked={Object.keys(selectedCharges).length === charges.length
                        && Object.keys(selectedCharges).length}
                        ref={input => {
                            if (input) {
                                const selectedCount = Object.keys(selectedCharges).length;
                                input.indeterminate = charges.length > selectedCount
                                    && selectedCount > 0;
                            }
                        }}
                        onChange={() => this.props.onToggle(false, this.tableRef)}
                    />
                ),
                sortable: false,
                filterable: false,
                resizable: false,
                minResizeWidth: 40,
                width: 40,
                className: "d-flex justify-content-center align-items-center"
            });
        }

        columns.push({
            id: "show-enter-report",
            Header: "Actions",
            // accessor: "completedDate",
            // accessor: original => moment(original.completedDate).format(this.dateFormat),
            Cell: ({ original }) => (
                <div>
                    <Button
                        className="p-1"
                        size="sm"
                        onClick={() => this.props.onViewReport(original.serviceId)}
                    >
                        Show Report
                    </Button>
                    {
                        (this.props.userRole.includes(UserTypes.accountManager) ||
                        this.props.userRole.includes(UserTypes.admin)) &&
                        <button
                            className="btn btn-sm btn-info ml-2"
                            onClick={() => this.props.onView(original.chargeId)}
                        >
                            View Charge
                        </button>
                    }
                </div>
            ),
            Filter: () => false,
            width: 160
        });
        if (isAdminView || isAccountManagerView) {
            columns.push({
                id: "merchandiser",
                Header: "Merchandiser",
                accessor: "merchandiser"
            });
            columns.push({
                Header: "Cat.",
                accessor: "category",
                id: "category",
                width: 50
            });
        }
        columns.push({
            id: "completedDate",
            Header: "Completed Date",
            // accessor: "completedDate",
            accessor: original => moment(original.completedDate).format(this.dateFormat),
            Filter: ({ filter, onChange }) => (
                <DatePicker
                    Format={this.dateFormat}
                    value={filter ? filter.value : null}
                    onChange={date => onChange(date)}
                    placeholder=""
                />
            )
        });
        columns.push({
            id: "dateReportSubmitted",
            Header: "Submitted Date",
            // accessor: "completedDate",
            accessor: original => moment(original.dateReportSubmitted).format(this.dateFormat),
            Filter: ({ filter, onChange }) => (
                <DatePicker
                    Format={this.dateFormat}
                    value={filter ? filter.value : null}
                    onChange={date => onChange(date)}
                    placeholder=""
                />
            )
        });
        columns.push({
            id: "jobDescription",
            Header: "Job",
            accessor: "jobDescription",
        });
        columns.push({
            id: "product",
            Header: "Product",
            accessor: "product",
        });
        columns.push({
            id: "retailer",
            Header: "Retailer",
            accessor: "retailer",
        });
        columns.push({
            id: "storeDescription",
            Header: "Store",
            accessor: "storeDescription",
        });
        columns.push({
            id: "serviceType",
            Header: "Service",
            accessor: "serviceType",
        });
        columns.push({
            id: "payrateFlat",
            Header: "Flat Pay Rate",
            accessor: "payrateFlat",
            width: 80,
            Filter: ({ filter, onChange }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ""}
                    className="form-control"
                    type="number"
                />
            )
        });
        columns.push({
            id: "payratePerHour",
            Header: "Pay Rate Per Hour",
            accessor: "payratePerHour",
            Filter: ({ filter, onChange }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ""}
                    className="form-control"
                    type="number"
                />
            )
        });
        columns.push({
            id: "hoursForBilling",
            Header: "Billable Hours",
            accessor: "hoursForBilling",
            Filter: ({ filter, onChange }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ""}
                    className="form-control"
                    type="number"
                />
            )
        });
        columns.push({
            id: "amount",
            Header: "Amount",
            accessor: original => (original.amount
                ? Math.round((original.amount + Number.EPSILON) * 100) / 100
                : null),
            width: 70,
            Filter: ({ filter, onChange }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ""}
                    className="form-control"
                    type="number"
                />
            )
        });
        columns.push({
            id: "allExceptions",
            Header: "Exceptions",
            accessor: "allExceptions",
        });
        columns.push({
            id: "approvalStatus",
            Header: "Status",
            accessor: "approvalStatus",
            Cell: ({ original }) => (
                <div
                    className="text-center"
                    style={{
                        color: MerchandiserInvoicingStatuses[original.approvalStatus].color
                    }}
                >
                    {MerchandiserInvoicingStatuses[original.approvalStatus].icon}
                    {/*
                    <div>{MerchandiserInvoicingStatuses[original.approvalStatus].title}</div>
                    */}
                </div>
            ),
            Filter: statusFilter
        });

        return columns.map(value => {
            value.headerClassName = "text-left";
            return value;
        });
    };

    render() {
        const { charges } = this.props;

        return (
            <ReactTable
                ref={this.tableRef}
                data={charges}
                columns={this.getColumns()}
                headerClassName="table-header"
                showPagination={false}
                pageSize={Math.max(charges.length, 20)}
                resizable
                className="-striped -highlight"
                filterable
                defaultSorted={[{
                    id: "completedDate",
                    desc: false
                }]}
                defaultFilterMethod={filterCaseInsensitive}
                getNoDataProps = {() => ({
                    style: {
                        zIndex: 0
                    }
                })}
                style={{
                    height: "calc(100vh - 250px)",
                }}
            />
        );
    }
}

ListChargesCharges.propTypes = {
    charges: PropTypes.array.isRequired,
    selectedCharges: PropTypes.object.isRequired,
    isAdminView: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    onViewReport: PropTypes.func.isRequired,
    onView: PropTypes.func.isRequired,
};

export default ListChargesCharges;
